import { render, staticRenderFns } from "./TblRawMatDetail.vue?vue&type=template&id=3b1d695c&scoped=true&"
import script from "./TblRawMatDetail.vue?vue&type=script&lang=js&"
export * from "./TblRawMatDetail.vue?vue&type=script&lang=js&"
import style0 from "./TblRawMatDetail.vue?vue&type=style&index=0&id=3b1d695c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1d695c",
  null
  
)

export default component.exports